import i18next from 'i18next';

import { isBeforeNow, addDays, getNumberOfDaysBetween, currentDate } from '#utils/date';
import {
  WORKSPACE_STATUS,
  SUBSCRIPTION_STATUS,
  FREE_TRIAL_STATUSES,
  SEAT_PLANS
} from '#constants/subscriptions';
import { ROLES, REMAINING_DAYS_FOR_ALERT } from '#constants/users';

export const INVITATION_STATUS = {
  PENDING: 'pending',
  EXPIRED: 'expired'
};

export const isPending = invitationStatus => invitationStatus === INVITATION_STATUS.PENDING;
export const isExpired = invitationStatus => invitationStatus === INVITATION_STATUS.EXPIRED;

export const INPUT_EMAIL = 'currentEmail';

export const isOwner = role => role === ROLES.OWNER;
export const isAdmin = role => role === ROLES.ADMIN;
export const isCollaborator = role => role === ROLES.LAWYER;

export const isOnFreeTrial = workspace => workspace?.subscriptionStatus === WORKSPACE_STATUS.FREE_TRIAL;

export const isFreeTrialOver = workspace =>
  isBeforeNow(workspace?.freeTrialEndDate || addDays(currentDate(), 1));

export const getFreeTrialEndDate = workspace =>
  workspace && workspace.freeTrialEndDate && new Date(workspace.freeTrialEndDate);

const daysRemainingOfFreeTrial = workspace =>
  getNumberOfDaysBetween(
    currentDate(),
    getFreeTrialEndDate(workspace) || addDays(currentDate(), REMAINING_DAYS_FOR_ALERT + 1)
  );

export const onLessThanTenDaysOfFreeTrial = workspace =>
  workspace && isOnFreeTrial(workspace) && daysRemainingOfFreeTrial(workspace) <= REMAINING_DAYS_FOR_ALERT;

// An expired subscription (hasValidAccess computed by the backend from its dates) is not subscribed anymore, so
// the user can get a new plan
export const isSubscribed = workspace =>
  workspace?.mercadoPagoSubscription?.status &&
  workspace.mercadoPagoSubscription.status !== SUBSCRIPTION_STATUS.CANCELLED &&
  workspace.hasValidAccess !== false;

// A cancelled subscription keeps the premium features while the paid period is valid (workspace.hasValidAccess)
export const hasPremiumPlan = workspace =>
  workspace?.mercadoPagoSubscription?.plan === SEAT_PLANS.PREMIUM &&
  !!workspace.mercadoPagoSubscription.status &&
  workspace.hasValidAccess !== false;

export const isFreeTrialStatus = status => FREE_TRIAL_STATUSES.includes(status);

export const getSubscription = (subscriptionStatus, statusText, currentWorkspace) => {
  const subscription = isFreeTrialStatus(subscriptionStatus)
    ? statusText
    : i18next.t(`SubscriptionBuilder:${currentWorkspace?.mercadoPagoSubscription?.plan}Name`);
  return subscription?.toUpperCase();
};
